import { Injectable } from '@angular/core';
import userDatashape from "../../../shared/datashapes/user.datashape";
import {first, map} from "rxjs";
import {GraphService} from "../../../kernel/graphql/services/graph.service";

@Injectable({
  providedIn: 'root'
})
export class UserApiService {

  constructor(
    private graphService: GraphService,
  ) { }

  getUser(id: string, dataShape: string = userDatashape) {
    return this.graphService
      .constructQuery<{ getUser: any }>(
        dataShape,
        'getUser',
        { id }
      )
      .pipe(
        first(),
        map(res => res.data)
      );
  }

  setUserAccess(id: string, enabled: boolean) {
    return this.graphService
      .constructMutation<{ setUserAccess: { id: string, enabled: boolean } }>(
        'setUserAccess',
        {id: 'ID!', enabled: 'Boolean!'},
        {id, enabled},
        ['id', 'enabled']
      )
      .pipe(first());
  }

  blackListUser(id: string) {
    return this.graphService
      .constructMutation<{ getUser: any }>(
        'blacklistUser',
        {id: 'ID!'},
        {id},
        ['id']
      )
      .pipe(
        first(),
        map(res => res.data)
      );
  }
}
